import Button from "@/components/Button";
import time from "@/assets/icons/time.svg";

interface HeroTextProps {
  heading: string;
  copy: string;
  buttonText: string;
  buttonLink: () => void;
  smallText?: string;
  iconPosition?: "left" | "right" | "none";
  buttonSize?: "lg" | "sm" | "md";
}

const HeroText = ({
  heading,
  copy,
  buttonText,
  buttonLink,
  smallText,
  iconPosition,
  buttonSize = "lg",
}: HeroTextProps) => {
  return (
    <div className="lc-flex lc-flex-1 lc-gap-6 lg:lc-gap-8 lc-flex-col lc-mb-10 md:lc-mb-20 lc-max-w-6xl lc-relative lc-z-[1]">
      <h1
        className={`lc-font-flecha lc-text-4xl lg:lc-text-5xl lc-leading-tight lc-text-white lc-max-w-4xl`}
      >
        {heading}
      </h1>
      <div
        className="lc-text-white lc-font-normal lc-font-azo-sans lc-max-w-2xl lc-text-md lg:lc-text-xl md:lc-mb-6"
        dangerouslySetInnerHTML={{ __html: copy }}
      />
      <div>
        <Button
          text={buttonText}
          onClick={buttonLink}
          size={buttonSize}
          iconPosition={iconPosition ? iconPosition : "right"}
        />
        {smallText && (
          <div className="lc-flex lc-gap-2 lc-items-center lc-mt-4">
            <img
              src={time}
              width={14}
              height={14}
              className="lc-w-[14px] lc-h-[14px]"
              alt=""
            />
            <p className="lc-text-white lc-font-normal lc-font-azo-sans lc-text-xs md:lc-text-base">
              {smallText}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default HeroText;
